import { Printer } from 'lucide-react'
import { Tooltip } from '@/components/ui/Tooltip'

export function PrintButton() {
  return (
    <Tooltip content="인쇄" placement="bottom">
      <button
        type="button"
        onClick={() => window.print()}
        className="p-2 rounded-lg text-disabled hover:text-[var(--text-secondary)] hover-surface transition-colors print:hidden"
        aria-label="인쇄"
      >
        <Printer className="w-5 h-5" />
      </button>
    </Tooltip>
  )
}
